import React from 'react';

import PolicyLabel from '../PolicyLabel';

import { POLICIES_STATUSES } from '../../constants';

import './styles.scss';

export default function PoliciesDescriptionsDashboard({ type }) {
  return (
    <div className="policies-descriptions-dashboard">
      <div className="policies-descriptions-dashboard__inner">
        {type.model.statuses.map((statusId) => {
          const status = POLICIES_STATUSES.find((x) => x.id === statusId);
          return (
            <div className="policies-descriptions-dashboard__item">
              <PolicyLabel colour={status.colour}>{status.name}</PolicyLabel>
              <p className="policies-descriptions-dashboard__item__description">
                {status.description}
              </p>
            </div>
          );
        })}
        <p className="policies-descriptions-dashboard__footnote">{__('policies-map-footnote')}</p>
      </div>
    </div>
  );
}
